import { validate } from "../../helpers/validate.js";
import { attributesIconSchema } from "./attributes.js";
import { guideIconHtml } from "@scalar-org/guide-icons";
const scalarIcon = {
  name: "scalar-icon",
  tagName: "scalar-icon",
  tiptapName: "custom_icon",
  attributeTransform: (content, attrs) => {
    const validated = validate(attributesIconSchema, {
      ...attrs,
      caption: attrs.caption || content,
      ...(attrs.width || attrs.height) && { size: "custom" }
    });
    return validated;
  },
  render: async (props) => {
    const transformed = scalarIcon.attributeTransform("", props);
    return transformed ? await guideIconHtml({
      src: transformed.src,
      title: transformed.title,
      classes: transformed.class?.split(" "),
      size: transformed.size
    }) : "";
  }
};
export {
  scalarIcon
};
//# sourceMappingURL=index.js.map
